
import React from 'react';
import { LegacyBonusSection, LegacyBonusItem } from '@/types/analysisTypes';
import { RenderInsightContentProps } from './types';
import { isNewBonusFormat } from '@/utils/bonus-section';

export const LegacyFormatInsight: React.FC<RenderInsightContentProps> = ({ 
  insightKey, 
  bonusSection 
}) => {
  if (isNewBonusFormat(bonusSection)) return null;
  
  const legacySection = bonusSection as LegacyBonusSection;
  const insight = legacySection[insightKey as keyof LegacyBonusSection];
  
  if (!insight || typeof insight !== 'object') return null;
  
  const legacyItem = insight as LegacyBonusItem;
  
  if (legacyItem.question || legacyItem.example) {
    return (
      <div className="mt-3">
        {legacyItem.question && (
          <p className="font-medium text-sm">{legacyItem.question}</p>
        )}
        {legacyItem.example && (
          <p className="mt-2 text-sm text-muted-foreground">{legacyItem.example}</p>
        )}
      </div>
    );
  }
  
  return null;
};
